import { store } from "@/services/store";
import { Link } from "react-router-dom";

const institutionalLinks = [
  "Sobre nós",
  "Trocas e Devoluções",
  "Fale conosco",
];

const supportLinks = [
  { icon: "ri-whatsapp-line", label: "WhatsApp" },
  { icon: "ri-mail-line", label: "E-mail" },
  { icon: "ri-question-line", label: "Central de Ajuda" },
];

const socials = [
  { icon: "ri-instagram-line", label: "Instagram" },
  { icon: "ri-facebook-circle-line", label: "Facebook" },
  { icon: "ri-tiktok-line", label: "TikTok" },
  { icon: "ri-pinterest-line", label: "Pinterest" },
  { icon: "ri-youtube-line", label: "YouTube" },
];

function VisaBadge() {
  return (
    <svg viewBox="0 0 48 30" role="img" aria-label="Visa" className="block h-8 w-12 rounded-md shadow-sm">
      <rect width="48" height="30" rx="4" fill="#1434CB" />
      <text x="24" y="20" textAnchor="middle" fontFamily="Georgia, serif" fontStyle="italic" fontWeight="700" fontSize="13" fill="#fff">
        VISA
      </text>
    </svg>
  );
}

function MastercardBadge() {
  return (
    <svg viewBox="0 0 48 30" role="img" aria-label="Mastercard" className="block h-8 w-12 rounded-md shadow-sm">
      <rect width="48" height="30" rx="4" fill="#fff" />
      <circle cx="20" cy="15" r="9" fill="#EB001B" />
      <circle cx="28" cy="15" r="9" fill="#F79E1B" />
      <path d="M24 8a9 9 0 0 1 0 14 9 9 0 0 1 0-14Z" fill="#FF5F00" />
    </svg>
  );
}

function EloBadge() {
  return (
    <svg viewBox="0 0 48 30" role="img" aria-label="Elo" className="block h-8 w-12 rounded-md shadow-sm">
      <rect width="48" height="30" rx="4" fill="#000" />
      <text x="24" y="20" textAnchor="middle" fontFamily="Arial, sans-serif" fontWeight="800" fontSize="13" fill="#fff">
        elo
      </text>
      <circle cx="35" cy="10" r="2" fill="#FFD400" />
      <circle cx="13" cy="20" r="2" fill="#00A4E0" />
    </svg>
  );
}

function PixBadge() {
  return (
    <svg viewBox="0 0 48 30" role="img" aria-label="Pix" className="block h-8 w-12 rounded-md shadow-sm">
      <rect width="48" height="30" rx="4" fill="#32BCAD" />
      <g transform="translate(24 15) rotate(45)" fill="#fff">
        <rect x="-8" y="-2" width="6" height="4" rx="1.4" />
        <rect x="2" y="-2" width="6" height="4" rx="1.4" />
        <rect x="-2" y="-8" width="4" height="6" rx="1.4" />
        <rect x="-2" y="2" width="4" height="6" rx="1.4" />
      </g>
    </svg>
  );
}

const paymentBrands = [
  { label: "VISA", Badge: VisaBadge },
  { label: "Mastercard", Badge: MastercardBadge },
  { label: "ELO", Badge: EloBadge },
  { label: "PIX", Badge: PixBadge },
];

export default function Footer() {
  return (
    <footer className="w-full bg-foreground-950 text-background-100">
      <div className="mx-auto grid max-w-none grid-cols-2 gap-x-8 gap-y-10 px-4 py-12 md:px-6 lg:grid-cols-5">
        <div className="col-span-2 lg:col-span-1">
          <div className="footer-brand-logo"><img src={`${import.meta.env.BASE_URL}rica-tanto-logo-transparent.png`} alt="Rica Tanto" /></div>
          <p className="mt-4 max-w-xs text-sm font-light leading-relaxed text-background-200/80">
            Acessórios que valorizam sua história. Estilo, qualidade e bom gosto sempre com você.
          </p>
          <div className="mt-5 flex flex-wrap gap-2">
            {socials.map((social) => (
              <a
                key={social.label}
                href="#"
                aria-label={social.label}
                rel="nofollow"
                className="flex h-9 w-9 items-center justify-center rounded-full border border-background-100/20 text-background-200 transition-colors hover:border-primary-500 hover:text-primary-400"
              >
                <i className={`${social.icon} text-lg`}></i>
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="mb-4 text-xs font-semibold uppercase tracking-widest text-background-50">
            Institucional
          </h4>
          <ul className="space-y-2.5">
            {institutionalLinks.map((link) => (
              <li key={link}>
                <Link
                  to={link === "Trocas e Devoluções" ? "/politica-de-trocas" : link === "Fale conosco" ? "/contato" : "/"}
                  className="text-sm font-light text-background-200/80 transition-colors hover:text-primary-400"
                >
                  {link}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="mb-4 text-xs font-semibold uppercase tracking-widest text-background-50">
            Atendimento
          </h4>
          <ul className="space-y-2.5">
            {supportLinks.map(link => <li key={link.label}><a href={link.label === 'WhatsApp' ? store.whatsapp : link.label === 'E-mail' ? `mailto:${store.email}` : '/contato'} className="flex items-center gap-2 text-sm text-background-200/80"><i className={link.icon} aria-hidden="true" />{link.label}</a></li>)}
          </ul>
        </div>

        <div>
          <h4 className="mb-4 text-xs font-semibold uppercase tracking-widest text-background-50">
            Formas de Pagamento
          </h4>
          <div className="flex flex-wrap gap-2">
            {paymentBrands.map(({ label, Badge }) => (
              <Badge key={label} />
            ))}
          </div>
          <h4 className="mb-3 mt-6 text-xs font-semibold uppercase tracking-widest text-background-50">
            Segurança
          </h4>
          <div className="flex items-start gap-2 text-sm font-light text-background-200/80">
            <span className="flex h-5 w-5 shrink-0 items-center justify-center text-primary-400">
              <i className="ri-shield-check-line text-base"></i>
            </span>
            <span>
              Compra 100% Segura
              <br />
              Seus dados protegidos
            </span>
          </div>
        </div>
      </div>

      <div className="border-t border-background-100/10">
        <div className="mx-auto flex max-w-none flex-col items-center justify-between gap-2 px-4 py-5 text-center md:flex-row md:px-6 md:text-left">
          <p className="text-xs font-light text-background-200/70">
            © 2026 Rica Tanto. Todos os direitos reservados.<br />{store.legalName} · CNPJ {store.cnpj}
          </p>
          <p className="text-xs font-light text-background-200/70">
            Desenvolvido por <a href="https://www.serraconsultora.com" target="_blank" rel="noopener noreferrer" className="transition-colors hover:text-primary-400">Serra Consultoria e Tecnologia</a>
          </p>
        </div>
      </div>
    </footer>
  );
}


